import React from 'react';

const DiagsPartner = ({ hasDiags, importDiags, setImportDiags }) => {

  if (hasDiags !== true) return null
  
  return (
    <div className='flex flex-col gap-6 mt-6'>
      <p className='h2'>Souhaitez-vous importer vos diagnostics maintenant ?</p>
      
      <div className='flex flex-col gap-3'>
        <div className={`flex items-center gap-3 border ${importDiags === true ? 'border-ih-blue' : 'border-ih-blue-30'} rounded-2xl p-5 bg-white cursor-pointer`} onClick={() => setImportDiags(true)}>
          <div className='w-max'>
            <div className={`w-6 h-6 rounded-full border border-ih-blue-30 ${importDiags === true && 'bg-ih-blue'}`}></div>
          </div>
          <p className='text-sm font-semibold'>Oui</p>
        </div>

        <div className={`flex items-center gap-3 border ${importDiags === false ? 'border-ih-blue' : 'border-ih-blue-30'} rounded-2xl p-5 bg-white cursor-pointer`} onClick={() => setImportDiags(false)}>
          <div className='w-max'>
            <div className={`w-6 h-6 rounded-full border border-ih-blue-30 ${importDiags === false && 'bg-ih-blue'}`}></div>
          </div>
          <p className='text-sm font-semibold'>Non, je préfère les importer plus tard</p>
        </div>
      </div>
    </div>
  )
}

export default DiagsPartner;
